import React from 'react';
import './styles.scss';
import { Table, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import shortid from 'shortid';
import { ServiceTicket } from './hooks';
import { Setting } from '../../../components/atoms/icons';

interface Props {
  serviceTickets: ServiceTicket[];
  isLoading: boolean;
}

function RenderTableServiceTickets(props: Props) {
  const { serviceTickets, isLoading } = props;
  const classNameHeader = 'color-placeholder fw-bold border-color-stroke border-bottom fw-normal pb-1 fz-14';

  return (
    <div
      className="border border-1 border-color-stroke w-100 mb-4 d-flex flex-column me-lg-2"
      style={{ borderRadius: '20px' }}
    >
      <div className="d-flex align-items-center justify-content-between pt-4 px-4 px-xl-5">
        <div className="fw-bold fz-14">Open Service Tickets</div>
        <Link
          className="rounded-pill fz-14 color-placeholder px-3 py-1 text-decoration-none"
          style={{ border: '2px solid #AEAEAE' }}
          to="/customer-support"
        >
          View All
        </Link>
      </div>
      <div className="flex-grow-1 py-4 flexible-center">
        {serviceTickets && serviceTickets.length ? (
          <div className="w-100 mt-4">
            <Table borderless responsive>
              <thead>
                <tr>
                  <th className={`${classNameHeader} ps-4 ps-xl-5`}>VM DEVICE ID</th>
                  <th className={classNameHeader}>USER</th>
                  <th className={`${classNameHeader} pe-4 pe-xl-5`}>EMAIL</th>
                </tr>
              </thead>
              <tbody>
                {serviceTickets.map((data, i) => (
                  <tr
                    key={shortid.generate()}
                    className={i % 2 !== 0 ? 'bg-solid align-middle' : 'align-middle'}
                    style={{ height: '50px' }}
                  >
                    <td className="fz-14 ps-4 ps-xl-5">{data.deviceId}</td>
                    <td className="fz-14">{data.name}</td>
                    <td className="fz-14 pe-4 pe-xl-5">{data.email}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : (
          <div className="w-100 flexible-center" style={{ minHeight: '200px' }}>
            {isLoading ? <Spinner animation="border" />
              : (
                <div className="flexible-center flex-column">
                  <div
                    className="rounded-circle flexible-center mb-2"
                    style={{ height: 65, width: 65, backgroundColor: '#F2F3F7' }}
                  >
                    <Setting />
                  </div>
                  <div className="fz-14">You have no service tickets yet.</div>
                </div>
              )}
          </div>
        )}
      </div>
    </div>
  );
}

export default React.memo(RenderTableServiceTickets);
